import {useState,useEffect} from "react";
import {Link} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageUploading from 'react-images-uploading';
import FormNoData from '../../../formNoData';
/* -- biz9 import start -- */
import {Image_Type,Image_Table,Image_Field,Image_Format,Image_Service,Image_Url,Image_Logic} from "biz9-image";
import {Store_Field} from "biz9-store";
import {Log,Num,Str,Obj} from "biz9-utility";
import {Message,Type,Url,Field,Title} from "../../../../constant";
import {Portal_Url,Portal_Field,Portal_Table,Portal_Type,Portal_Remote_Data,Portal_Remote_Image,Portal_Remote_CMS} from "biz9-portal-app";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,User,Template,Storage,System} from "../../../../project";
import {Data_Logic} from "biz9-data-app";
/* -- biz9 import end -- */
const Item_Value_Edit = (props) => {
    const [formNoDataShow, setFormNoDataShow] = useState(true);
    const [val_id,setValId] = useState(0);
    const [hide_value_row_edit,setHideValueRowEdit] = useState(false);
    const [hide_row_image,setHideRowImage] = useState(true);
    const [hide_btn_image_post,setHideBtnImagePost] = useState(false);
    const [images,setImages] = useState([]);
    const image_max_count = 1;
    const [image_primary,setImagePrimary] = useState([]);
    useEffect(() => {
    },[props]);
    const btn_add_row = () => {
        let title = 'new_item';
        props.item['field_'+String(Number(props.field_values.length+1))] = title;
        props.onFieldValuesUpdate([...props.field_values, {id:Str.get_id(), row_id: props.field_values.length+1, title:title, value: "" },]);
        setFormNoDataShow(false);
    };
    const btn_remove_row = (id) => {
        if (window.confirm(Message.CONFIRM)) {
            const item_match = props.field_values.find(item_find => item_find.id === id);
            delete props.item['field_'+item_match.row_id];
            delete props.item[Str.get_title_url(item_match.title)];
            let new_field_values = props.field_values.filter((row) => row.id !== id)
            post_item(new_field_values);
        }
    };
    async function post_item(new_field_values){
        props.toast_loading(Message.SAVING);
        let full_prop_str = "";
        for(const prop in props.item){
            full_prop_str = String(prop + " "+full_prop_str);
        }
        for(let b = 1; b < 30; b++){
            const exists = Str.check_if_str_exist(full_prop_str,"field_"+b);
            let title = Str.get_title_url(props.item["field_"+b]);
            if(exists){
                delete props.item["field_"+b];
                delete props.item[title];
            }
        }
        for(let a=0;a<new_field_values.length;a++){
            new_field_values[a].row_id = a+1;
            props.item['field_'+(a+1)] = new_field_values[a].title;
            props.item[Str.get_title_url(new_field_values[a].title)] = new_field_values[a].value;
        }
        let option = {overwrite:true,clean:true};
        let [response,data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST),props.item.table,props.item,option);
        props.onItemUpdate(data);
        props.onFieldValuesUpdate(new_field_values);
        props.toast_success(response.message);
    };
    const update_field = (type,id,value,post_data) => {
        //const item_match = props.field_values.find(item_find => item_find.id === id);--test 3-11
        let new_field_values = [];
        if(type == Portal_Field.TITLE){
            new_field_values = props.field_values.map((row) => (row.id === id ? { ...row, title:value } : row))
            props.onFieldValuesUpdate(new_field_values);
        }else if(type == Field.VALUE){
            new_field_values = props.field_values.map((row) => (row.id === id ? { ...row, value: value } : row));
            props.onFieldValuesUpdate(new_field_values);
        }else if(type == Image_Field.IMAGE_FILENAME){
            new_field_values = props.field_values.map((row) => (row.id === id ? { ...row, value: value, image_filename:value } : row));
            props.onFieldValuesUpdate(new_field_values);
        }
        if(post_data){
            post_item(new_field_values);
        }
    };
    //  image -- start
    const onImagePrimaryDelete = () => {
        if (window.confirm(Message.CONFIRM)) {
            setImagePrimary([]);
            setHideBtnImagePost(false);
        }
    };
    async function set_image_delete(filename: any) {
        let image = images.find(item => item.image_filename == filename);
        if(!Obj.check_is_empty(image)&&!Str.check_is_null(image.id)){
            let [response,data] = await Portal_Remote_Data.delete(App.get_url(Portal_Url.DATA_DELETE),Image_Table.IMAGE,image.id);
        }
    };
    //  image-row -- start
    async function onImageRowChange(image_upload, addUpdateIndex){
        props.toast_loading(Message.SAVING);
        setHideBtnImagePost(true);
        setHideRowImage(true);
        setHideValueRowEdit(true);
        let image = Data_Logic.get(Image_Table.IMAGE,0,{data:{base64:image_upload[0][Image_Field.BASE64],extension:Str.get_file_extension(image_upload[0][Image_Field.FILE][Image_Field.NAME])}});
        let [response,data] = await Portal_Remote_Image.post(App.get_url(Portal_Url.IMAGE_POST),[image]);
        if(data){
            props.toast_dismiss();
            setHideBtnImagePost(false);
            setHideValueRowEdit(false);
            update_field(Image_Field.IMAGE_FILENAME,val_id,data[0].image_filename,true);
        }else{
            props.toast_dismiss();
        }
    };
    const onImageRowDelete = () => {
        if (window.confirm(Message.CONFIRM)) {
            setImagePrimary([]);
            setHideBtnImagePost(false);
        }
    };
    async function set_image_row_delete(filename: any) {
        let image = images.find(item => item.image_filename == filename);
        setImages(images.filter(item => item.image_filename !== filename));
        if(!Obj.check_is_empty(image)&&!Str.check_is_null(image.id)){
            let [response,data] = await Portal_Remote_Data.delete(App.get_url(Portal_Url.DATA_DELETE),Image_Table.IMAGE,image.id);
        }
    };
    async function btn_back_image_value_row(){
        setHideRowImage(true);
        setHideValueRowEdit(false);
    };
    async function btn_image_value_row(id){
        setValId(id);
        setHideRowImage(false);
        setHideValueRowEdit(true);
    };
    //  image-row -- end
    const handle_submit = (event) => {
        event.preventDefault();
    };
    return (
            <div className="settings-card">
            <div className="settings-card-head bg-light">
            <h4>Values</h4>
            </div>
            <form onSubmit={handle_submit}>
            <div className="settings-card-body">
            {/* ROW-START */}
            <div className='biz_row_start' style={{ display: hide_value_row_edit ? 'none' : 'block' }} >
            {props.field_values.length<=0 && <FormNoData/>}
            {props.field_values.map((row) => (
                        <div className="row">
                        <div className="col-md-12">
                        <div className="form-wrap">
                        <label className="col-form-label">
                        {Title.LABEL_TITLE}
                        </label>
                        <div className="form-wrap mb-1">
                        <input value={row.title} onChange={(e) => update_field(Portal_Field.TITLE,row.id,e.target.value,false)} type="text" className="form-control" placeholder={Title.LABEL_TITLE} onBlur={(e) => update_field(Portal_Field.TITLE,row.id,e.target.value,true)} />
                        </div>
                        </div>
                        <div className="form-wrap">
                        <label className="col-form-label">
                        Value
                        </label>
                        <div className="form-wrap">
                        <textarea hidden={row.image_filename} value={!Str.check_is_null(row.value)?row.value:''} onChange={(e) => update_field(Field.VALUE,row.id,e.target.value,false)} onBlur={(e) => update_field(Field.VALUE,row.id,e.target.value,true)} className="form-control text-area" placeholder="Value"  />
                        </div>
                        </div>
                        </div>
                        <div style={{ textAlign: 'left' }}>
                        <Link onClick={(e)=>{{e.preventDefault(); btn_image_value_row(row.id)}}} to={"#"} className="mb-4" style={{ paddingRight:'10px' }} >
                        <FeatherIcon icon="camera" />
                        <img style={{ padding:"10px"}} hidden={!row.image_filename}  src={Image.get_url(row.image_filename,Image_Format.SQUARE_THUMB)} alt=""  height="200" width="200" />
                        </Link>
                        <Link  onClick={(e)=>{{e.preventDefault(); btn_remove_row(row.id)}}}to="#" className="mb-4" >
                        <FeatherIcon icon="trash-2" />
                        </Link>
                        </div>

                        <hr/>
                        </div>
                        ))}

            <div className="review-btn text-center">
                <Link onClick={(e)=>{{ e.preventDefault();btn_add_row()}}} to={"#"} className="btn btn-dark text-white">
                {" "}
            <i className="ti ti-loader-3 me-1 rotate" /> Add{" "}
            </Link>
                </div>
                </div>
                {/* ROW-END */}

            {/* ROW-START */}
            <div className='biz_row_start'>
                <div className="col-md-12" hidden={hide_row_image}>
                <Link onClick={(e)=>{{e.preventDefault();btn_back_image_value_row()}}} to={'#'} className="nav-link" >
                {"<- Back"}
            </Link>
                <div className="form-wrap mb-3 mt-5">
                <ImageUploading
                value={image_primary}
            onChange={onImageRowChange}
            maxNumber={image_max_count}
            dataURLKey={Image_Field.BASE64}>
            {({
                    imageList,
                    onImageUpload,
                    onImageRemoveAll,
                    onImageUpdate,
                    isDragging,
                    dragProps,
                    }) => (
                        <div className="upload__image-wrapper">
                        <button hidden={hide_btn_image_post} className="btn btn-secondary mb-2"
                        style={isDragging ? { color: 'red' } : undefined} onClick={() =>  onImageUpload()}
                        {...dragProps} >
                        Image
                        </button>
                        &nbsp;
                        {imageList.map((image, index) => (
                                    <div key={index} className="image-item">
                                    <img  src={Image.get_url(image.image_filename,Image_Format.SQUARE_THUMB)} alt=""  height="200" width="200" />
                                    <div className="image-item__btn-wrapper">
                                    <Link onClick={() => onImageRowDelete() } to="#" className="mb-2" >
                                    <FeatherIcon icon="trash-2" />

                                    </Link>
                                    </div>
                                    </div>
                                    ))}
                        </div>
                        )}
            </ImageUploading>
                </div>
                </div>

                </div>
                {/* ROW-END */}
            </div>
                </form>

                </div>
                );
};
export default Item_Value_Edit;
